import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  computed, PropType, ref,
} from 'vue';
import { positions, Positions } from '@/common/Tooltip/data';


export default /*#__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
  class: { type: String, default: 'bg-light-green-9' },
  position: { type: String as PropType<Positions>, default: Positions.right },
  title: { type: String, required: true },
},
  setup(__props) {

const props = __props;



const setting = ref(computed(() => positions[props.position as Positions]));


return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createBlock(_component_q_tooltip, {
    class: _normalizeClass(props.class),
    anchor: setting.value.anchor,
    self: setting.value.self
  }, {
    default: _withCtx(() => [
      _createElementVNode("strong", null, _toDisplayString(props.title), 1)
    ]),
    _: 1
  }, 8, ["class", "anchor", "self"]))
}
}

})